"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Better global support (for web/service workers)≥
var get_win_1 = require("get-win");
/**
 * Finds the location object, checking for polyfill and falling back to empty object.
 */
function get() {
    var window = get_win_1.get();
    return ((window.history && window.history.location) ||
        window.location || { href: "" });
}
exports.get = get;
//# sourceMappingURL=index.js.map